import { render, staticRenderFns } from "./TicketMainSection.vue?vue&type=template&id=c16a4bb0&"
import script from "./TicketMainSection.vue?vue&type=script&lang=js&"
export * from "./TicketMainSection.vue?vue&type=script&lang=js&"
import style0 from "./TicketMainSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports